export enum OrderLineStatus {
    Incident = 'INCIDENT',
    Damage = 'DAMAGE',
    Missing = 'MISSING',
    Packed = 'PACKED',
    Pending = ''
}
